export default "__VITE_PUBLIC_ASSET__0e7a7fe7__"